import { createSelector } from 'reselect';
import path from 'ramda/es/path';

import { APP_ACCESS, APP_CAFETERIA, APP_DNEVNIK } from 'app/common/constants/services';
import { getIsAppConnected } from 'app/selectors/applications';
import isToday from 'app/selectors/isToday';
import { getIsStudent } from 'app/selectors/user';
import applications from 'app/components/Children/applications';


/**
* Подключенность приложений и есть ли события для ребенка в заданную дату
* Событий нет, если нет данных только при всех подключенных приложениях
*/
const makeNothing = () => createSelector(
  [
    (state, { id }) => state.passages.short[id],
    state => state.cafeteria.costs,
    ({ hasMarks }) => hasMarks,
    ({ hasHomework }) => hasHomework,
    isToday,
    (state, { id }) => app => getIsAppConnected(state, { id, app }),
    (_, { id }) => id,
    getIsStudent,
    (state, { id }) => path(['students', 'data', id], state) || {},
    (state, { id }) => path(['students', 'data', id, 'passagesExternalService']),
  ], (
    passages,
    cafe,
    hasMarks,
    hasHomework,
    isTodayNow,
    isConnected,
    id,
    isStudent,
    student,
    isPassagesExternal
  ) => {
  const connectedAvailable = applications.map((app) => {
    if (app === APP_ACCESS) {
      // проходы не сегодняшенго дня всегда доступны
      return (isPassagesExternal || (isConnected(app) ? true : !isTodayNow));
    }
    if (app === APP_CAFETERIA) {
      // отсутствующая столовая считается подключенной (не отображается заглушка)
      return (isConnected(app) || !student.hasCafeteria || student.cafeteriaExternalService);
    }
    if (app === APP_DNEVNIK) {
      // отсутствующий дневник считается подключенным (не отображается заглушка)
      return (isConnected(app) || !student.hasDnevnik);
    }
    return isConnected(app);
  });

  return ({
    connected: connectedAvailable,
    noData: !connectedAvailable.includes(false) // все доступные подключены
      && !(
        (passages && passages.count && !isStudent) // проходы
        || cafe.spent[id] // кафе
        || hasMarks
        || hasHomework
      ),
  });
}
);

export default makeNothing;
